import { ReactElement } from 'react';

import { useHirePlanFormStepStore } from '../../../stores/useHirePlanFormStepStore';
//import { ServidorValidationForm } from './steps/ServidorValidationForm';
import { BeneficiaryForm } from './steps/DependentsForm';
import { AceiteForm } from './steps/AceiteForm';
import { ConfirmForm } from './steps/ConfirmForm';
import { useRouteLoaderData } from 'react-router-dom';
import ValidacaoCadastro from '../../../pages/AuthOdontoGroup';
import FunctionaryForm from './steps/functionary/functionaryForm';

export function HirePlanFormStepHandler(): ReactElement {
  const step = useHirePlanFormStepStore(state => state.step);

  switch (step) {
    case 1: {
      return <ValidacaoCadastro />;
    }

    case 2: {
      return <FunctionaryForm />;
    }

    case 3: {
      return <AceiteForm />;
    }

    case 4: {
      return <ConfirmForm />;
    }

    default: {
      return <ValidacaoCadastro />;
    }
  }
}
